/* eslint-disable react-hooks/exhaustive-deps */
import Axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import { AppContext } from "../MainComponents/AppContext";
import AlertModal from "../MainComponents/AlertMessagePopup";
import LoaderGif from "../../images/365 loading.gif";
import moment from "moment";
import AuthenticationContext from "../../Store/Authentication-Context";

const SyncOrgDataModal = props => {
    const divStyle = {
        display: props.displayModal ? "block" : "none",
        zIndex: "10050",
    };
    const { setAuthContext } = useContext(AuthenticationContext);
    const [inProgress, setInProgress] = useState(false);
    const [appContext] = useContext(AppContext);
    const [lastSyncTime, setLastSyncTime] = useState("N/A");
    const [alertMessage, setAlertMessage] = useState({
        header: "",
        message: "",
    });
    const [AlertPop, setAlertPop] = useState(true);
    function closeAlertModal(alertMessage) {
        setAlertMessage({
            header: "Error",
            message: alertMessage,
        });
        setAlertPop(false);
    }

    function cancelAlertClick() {
        setAlertPop(true);
    }

    async function getAppContextData( attr) {
        var tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        var isloaded = false;
        if (attr === "users" && appContext.users) {
            appContext.users.isloaded = isloaded;
            appContext.users.value = {};
        }
        if (attr === "groups" && appContext.groups) {
            appContext.groups.isloaded = isloaded;
            appContext.groups.value = {};
        }
        if (attr === "sites" && appContext.sites) {
            appContext.sites.isloaded = isloaded;
            appContext.sites.value = {};
        }
        if (attr === "teams" && appContext.teams) {
            appContext.teams.isloaded = isloaded;
            appContext.teams.value = {};
        }
        
        let data = await Axios.get(API_ROUTE + Routes.SYNC_365_DATA(appContext.orgId, attr), config)
            .then((response) => {
                isloaded = true;
                return JSON.parse(response.data);
            })
            .catch((reason) => {
                setInProgress(false);
                closeAlertModal(reason.message);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
        switch (attr) {
            case "users":
                {
                    data = data.map((x) => (
                        {
                            ...x,
                            mailbox: false,
                            archiveMailbox: false,
                            onedrive: false,
                            site: false,
                            itemType: "user",
                            selected: false,
                            excluded: false
                        }));
                    if (appContext.users) {
                        appContext.users.isloaded = isloaded;
                        appContext.users.value = data;
                    }
                    break;
                }
            case "groups":
                {
                    data = data.map((x) => (
                        {
                            ...x,
                            mailbox: false,
                            groupMailbox: false,
                            archiveMailbox: false,
                            onedrive: false,
                            site: false,
                            groupSite: false,
                            itemType: "group",
                            selected: false,
                            excluded: false
                        }));
                    if (appContext.groups) {
                        appContext.groups.isloaded = isloaded;
                        appContext.groups.value = data;
                    }
                    break;
                }
            case "sites":
                {
                    data = data.map((x) => (
                        {
                            ...x,
                            site: false,
                            itemType: "site",
                            selected: false,
                            excluded: false
                        }));
                    if (appContext.sites) {
                        appContext.sites.isloaded = isloaded;
                        appContext.sites.value = data;
                    }
                    break;
                }
            case "teams":
                {
                    data = data.map((x) => (
                        {
                            ...x,
                            teams: false,
                            teamsChat: false,
                            itemType: "team",
                            selected: false,
                            excluded: false
                        }));
                    if (appContext.teams) {
                        appContext.teams.isloaded = isloaded;
                        appContext.teams.value = data;
                    }
                    break;
                }
            default:
                break;
        }
    }

    function closeModal(e) {
        props.closeModal(true);
    }

    async function HandleSyncOrgData() {
        setInProgress(true);
         await updateSyncOrgData();
        var context = await refreshAppContext();
        setInProgress(false);
        if (context)
            props.closeModal(true);
    }

    async function refreshAppContext() {
        
        await getAppContextData( "sites");
        
        await getAppContextData("users");
        
        await getAppContextData("groups");
        
        await getAppContextData("teams");

        return true;
    }

    async function getSyncDate() {
        var tokenString = await setAuthContext("", new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        
        await Axios.get(API_ROUTE + Routes.SYNC_STATE(appContext.orgId) , config)
            .then((response) => {

                var result = JSON.parse(response.data);
                if (result)
                    setLastSyncTime(getFormattedDateTime(result.lastSyncTime));

            })
            .catch((reason) => {
                setInProgress(false);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
                console.log(reason);

            });
    }

    async function updateSyncOrgData() {
        var tokenString = await setAuthContext("", new Date());
        let jsonRequest = {
            type: "Incremental"
        };

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        let payload = {
            postString: JSON.stringify(jsonRequest),
            method: "POST",
            url: "/Organizations/" + appContext.orgId + "/Sync",
            orgId: appContext.orgId,
        };

        await Axios.post(API_ROUTE + Routes.SYNC_ORG_DATA, payload, config)
            .then((response) => {
                console.log(response.data);
                return response.data;
            })
            .catch((reason) => {
                setInProgress(false);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
                console.log(reason);
            });
    }

    function getFormattedDateTime(dateTime) {
        let syncDate = moment(dateTime);
        let year = syncDate.format("YYYY");
        let month = syncDate.format("MM");
        let day = syncDate.format("DD");
        let hour = syncDate.format("HH");
        let minute = syncDate.format("mm");
        return `${day}/${month}/${year} ${hour}:${minute}`;
    }

    useEffect(() => {
        getSyncDate();
    }, [props.refresh]);

    return (
        <div>
            <div
                style={divStyle}
                className="modal"
                id="exampleModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content" style={{ width: "500px", height:"250px"}}>
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Sync Data
                            </h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
                        </div>
                        <div className="modal-body" style={{ height: "400px", minWidth: "100%", width: "inherit" }}>
                            <div className="ag-theme-alpine" style={{width: "100%", height: "100%", }} >
                                <p>The function resyncs our cache with your AzureAD, your last sync was at <b>{lastSyncTime}</b></p>
                                <p>Do you want to continue.</p>                               
                            </div>
                        </div>
                        <div className="modal-footer">
                            {inProgress &&
                                <div>
                                    <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '35vh' }}>
                                        <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                                    </div>
                                </div>
                            }
                            {!inProgress &&
                                <div>
                                    <button onClick={HandleSyncOrgData} type="submit" className="btn btn-primary btn-sm">
                                    Yes
                                    </button>&nbsp;
                                    <button onClick={closeModal} className="btn btn-outline-primary btn-sm">
                                        No
                                    </button>
                                </div>
                            }
                            
                        </ div>
                    </div>
                </div>
            </div>
            <AlertModal displayModal={!AlertPop} closeModal={cancelAlertClick} message={alertMessage} />
            <div data-act-control-type="modalPopupBackground" id="RepAdd_backgroundElement" className="Background" style={{ display: props.displayModal ? "block" : "none", backgroundColor: "black", opacity: "0.8", position: "fixed", left: "0px", top: "0px", zIndex: "10000", width: "100%", height: "100%" }} />
        </div>

    );
};

export default SyncOrgDataModal;
